import { render, staticRenderFns } from "./FlagDocument.vue?vue&type=template&id=1c7b2d34&scoped=true&"
import script from "./FlagDocument.vue?vue&type=script&lang=js&"
export * from "./FlagDocument.vue?vue&type=script&lang=js&"
import style0 from "./FlagDocument.vue?vue&type=style&index=0&id=1c7b2d34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7b2d34",
  null
  
)

export default component.exports